import { render, staticRenderFns } from "./BriefEditor.vue?vue&type=template&id=75426ade&"
import script from "./BriefEditor.vue?vue&type=script&lang=js&"
export * from "./BriefEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports